/* eslint-disable no-use-before-define */
/* eslint-disable default-case */
/* eslint-disable react-hooks/exhaustive-deps */
import {
	Flex,
	Icon,
	IconButton,
	Image,
	Tooltip,
	Box,
	chakra,
	Button,
	Badge,
	Text,
} from '@chakra-ui/react'
import { NavLink, useHistory, useLocation } from 'react-router-dom'
import GreneLogo from '../../assets/images/grene-logo.png'
import { SidebarOptions } from './sidebar.options'
import React, { useState, useEffect } from 'react'
import { useAuthContext } from '../../context/auth.context'
import { sharedConst } from '../../utils/action.constant'
import { sidebarConst } from '../../utils/action.constant'
import { useSharedContext } from '../../context/shared.context'
import { useSidebarContext } from '../../context/sidebar.context'
import { useLanguageContext } from '../../context/locale.context'
import { useLoadActivityCounts } from '../../hooks/shared.hooks'
import ButtonCTA from '../globalComponents/button'
import SVGIcon from '../../assets/svgIcons'

export default function Sidebar(props) {
	const { mutate: statsMutate, data } = useLoadActivityCounts()
	let history = useHistory()
	const location = useLocation()
	const {
		state: { authData },
	} = useAuthContext()
	const {
		state: { locale },
	} = useLanguageContext()
	const {
		state: { sidebarCollapsed },
		dispatch: sidebarDispatch,
	} = useSidebarContext()

	const { dispatch } = useSharedContext()
	const [activePath, setactivePath] = useState(null)
	// const [isCollapsedSidebar, setIsCollapsedSidebar] = useState(false)
	// const [dummyText, setDummyText] = useState(null)

	useEffect(() => {
		statsMutate({ flag: 0 })
	}, [])

	// useEffect(() => {
	//   console.log('inside ue [cs]')
	//   setDummyText('dummyText')
	// },[isCollapsedSidebar])

	useEffect(() => {
		if (location.pathname === '/export' || location.pathname === '/report') {
			if (authData.asset_flag_export === 0) {
				history.push('/files')
				dispatch({
					type: sharedConst.SET_ACTION_PANEL_VIEW,
					view: 'QUEUE_SETUP_VIEW',
				})
				dispatch({
					type: sharedConst.CLEAR_ACTIVITY_SELECTION,
				})
			}
		}
	}, [authData])

	const openCollapse = () => {
		localStorage.setItem('isCollapsed', false)
		sidebarDispatch({ type: sidebarConst.SET_EXPANDED })
	}

	const CheckCount = menuItemKey => {
		if (data && data[menuItemKey]) {
			return data[menuItemKey]
		} else {
			return 0
		}
	}
	const onClickFun = menuItem => {
		if (menuItem.name.toLowerCase() === 'home') {
			dispatch({
				type: sharedConst.SET_ACTION_PANEL_VIEW,
				view: 'QUEUE_SETUP_VIEW',
			})
			dispatch({
				type: sharedConst.CLEAR_ACTIVITY_SELECTION,
			})
		}
	}
	const collapsedOnClickFun = menuItem => {
		if (menuItem.name.toLowerCase() === 'home') {
			dispatch({
				type: sharedConst.SET_ACTION_PANEL_VIEW,
				view: 'QUEUE_SETUP_VIEW',
			})
			dispatch({
				type: sharedConst.CLEAR_ACTIVITY_SELECTION,
			})
		}
		localStorage.setItem('isCollapsed', true)
	}
	const btnName = (menuItem, badgeCount) => {
		let bdBg = activePath === menuItem.pathname ? 'brand.700' : '#FFE36D'
		let bdclr = activePath === menuItem.pathname ? '#FFFFFF' : '#000000'
		return (
			<React.Fragment>
				{locale[menuItem.name] || menuItem.name}
				{menuItem.isBadge && badgeCount > 0 && (
					<Badge
						ml='3'
						w='25px'
						h='25px'
						fontSize='11px'
						fontWeight={500}
						color={bdclr}
						bg={bdBg}
						paddingTop='6px'
						borderRadius='full'
					>
						{CheckCount(menuItem.key)}
					</Badge>
				)}
			</React.Fragment>
		)
	}

	const collapsedBtnData = (menuItem, badgeCount) => {
		let bdBg = activePath === menuItem.pathname ? 'brand.700' : '#FFE36D'
		let iconFill = activePath === menuItem.pathname ? '#000000' : '#009B76'
		return (
			<React.Fragment>
				<Flex flexDir='column' justifyContent='space-around' h='100%'>
					<Box
						display='flex'
						alignItems='center'
						justifyContent='center'
						cursor='pointer'
						mb='1px'
						mt='5px'
					>
						{menuItem.name === 'Search' ? (
							<SVGIcon
								iconName='SearchSvg'
								svgProps={{ width: '18', height: '18', viewBox: '0 0 18 18' }}
								pathProps={{ fill: iconFill }}
							/>
						) : menuItem.name === 'Calendar' ? (
							<SVGIcon
								iconName='CalendarSvg'
								svgProps={{ width: '18', height: '18', viewBox: '0 0 18 18' }}
								pathProps={{ fill: iconFill }}
							/>
						) : menuItem.name === 'Delayed' ? (
							<SVGIcon
								iconName='DelayedSvg'
								svgProps={{ width: '18', height: '18', viewBox: '0 0 18 18' }}
								pathProps={{ fill: iconFill }}
							/>
						) : menuItem.name === 'Focus List' ? (
							<SVGIcon
								iconName='FocusSvg'
								svgProps={{ width: '18', height: '18', viewBox: '2 5 18 18' }}
								pathProps={{ fill: iconFill }}
							/>
						) : menuItem.name === 'Updates' ? (
							<SVGIcon
								iconName='UpdateSvg'
								svgProps={{ width: '18', height: '18', viewBox: '0 0 18 18' }}
								pathProps={{ fill: iconFill }}
							/>
						) : menuItem.name === 'New Request' ? (
							<SVGIcon
								iconName='NewRequestSvg'
								svgProps={{ width: '18', height: '18', viewBox: '0 0 18 18' }}
								pathProps={{ fill: iconFill }}
							/>
						) : menuItem.name === 'Queues' ? (
							<SVGIcon
								iconName='QueueSvg'
								svgProps={{ width: '18', height: '18', viewBox: '0 0 18 18' }}
								pathProps={{ fill: iconFill }}
							/>
						) : menuItem.name === 'Requests' ? (
							<SVGIcon
								iconName='RequestSvg'
								svgProps={{ width: '18', height: '18', viewBox: '0 0 18 18' }}
								pathProps={{ fill: iconFill }}
							/>
						) : menuItem.name === 'Chats' ? (
							<SVGIcon
								iconName='ChatSvg'
								svgProps={{ width: '18', height: '18', viewBox: '0 0 18 18' }}
								pathProps={{ fill: iconFill }}
							/>
						) : menuItem.name === 'Doc Repository' ? (
							<SVGIcon
								iconName='DocRepositorySvg'
								svgProps={{ width: '18', height: '18', viewBox: '0 0 18 18' }}
								pathProps={{ fill: iconFill }}
							/>
						) : menuItem.name === 'Dashboard' ? (
							<SVGIcon
								iconName='DashboardSvg'
								svgProps={{ width: '18', height: '18', viewBox: '0 0 18 18' }}
								pathProps={{ fill: iconFill }}
							/>
						) : menuItem.name === 'Web Access' ? (
							<SVGIcon
								iconName='WebAccessSvg'
								svgProps={{ width: '18', height: '18', viewBox: '0 0 18 18' }}
								pathProps={{ fill: iconFill }}
							/>
						) : menuItem.name === 'Preferences' ? (
							<SVGIcon
								iconName='PreferencesSvg'
								svgProps={{ width: '18', height: '18', viewBox: '0 0 18 18' }}
								pathProps={{ fill: iconFill }}
							/>
						) : null}
					</Box>
					{locale[menuItem.name] || menuItem.name}
					{/* {menuItem.isBadge && badgeCount > 0 && (
          <Badge
            ml="3"
            w="25px"
            h="25px"
            fontSize="11px"
            fontWeight={500}
            color={bdclr}
            bg={bdBg}
            paddingTop="6px"
            borderRadius="full"
          >
            {CheckCount(menuItem.key)}
          </Badge>
        )} */}
				</Flex>
			</React.Fragment>
		)
	}
	const loadSideBarData = (menuItem, index) => {
		let badgeCount = CheckCount(menuItem.key)
		let mbPx =
			menuItem.name === 'Calendar' ||
			menuItem.name === 'Queues' ||
			menuItem.name === 'Dashboard'
				? '16px'
				: '0px'

		return (
			<NavLink
				isActive={(match, location) => {
					if (!match) {
						return false
					}
					if (match.url === menuItem.pathname) {
						setactivePath(menuItem.pathname)
						return true
					}
					return false
				}}
				to={menuItem}
				key={index}
			>
				<ButtonCTA
					children={btnName(menuItem, badgeCount)}
					variant='sidebarButton'
					onClick={onClickFun(menuItem)}
					mt='7px'
					mr='2px'
					isActive={activePath === menuItem.pathname}
					mb={mbPx}
				/>
			</NavLink>
		)
	}

	const loadCollapsedSideBarData = (menuItem, index) => {
		let badgeCount = CheckCount(menuItem.key)

		return (
			<NavLink
				isActive={(match, location) => {
					if (!match) {
						return false
					}
					if (match.url === menuItem.pathname) {
						setactivePath(menuItem.pathname)

						return true
					}
					return false
				}}
				to={menuItem}
				key={index}
			>
				<ButtonCTA
					children={collapsedBtnData(menuItem, badgeCount)}
					variant='collapsedSidebarButton'
					onClick={collapsedOnClickFun(menuItem)}
					isActive={activePath === menuItem.pathname}
				/>
			</NavLink>
		)
	}

	const loadSideBar = (menuItem, index) => {
		if (menuItem.name === 'Gantt Chart') {
			if (authData?.asset_type_flag_enable_gantt_chart === 1) {
				return loadSideBarData(menuItem, index)
			}
		} else if (menuItem.name === 'Realtime Dashboard') {
			if (authData?.asset_type_flag_enable_dashboard === 1) {
				return loadSideBarData(menuItem, index)
			}
		} else if (menuItem.name === 'Document Repository') {
			if (authData?.organization_flag_document_repository_enabled === 1) {
				return loadSideBarData(menuItem, index)
			}
		} else {
			return loadSideBarData(menuItem, index)
		}
	}

	//collapsed sidebar
	const collapsedSidebar = () => {
		return (
			<>
				<Flex maxW='90px' minW='90px' height='100%' flexDir='column'>
					<Flex
						minH='60px'
						pt='15px'
						pl='25px'
						borderBottom='0.5px solid #F1F3F9'
					>
						<Flex
							flexDir='column'
							justifyContent='space-evenly'
							mr='13px'
							cursor='pointer'
							onClick={openCollapse}
						>
							{/* <Image src={greneIcon} maxW='2.25rem' /> */}
							<SVGIcon
								iconName='GreenLogoLineSvg'
								svgProps={{
									width: '36',
									height: '10',
									viewBox: '0 0 36 10',
								}}
								// pathProps={{ fill: '#009B76' }}
							/>
							<Box color='#000000' fontSize='14px' fontWeight={400}>
								{locale['Menu'] || 'Menu'}
							</Box>
						</Flex>
						<Box
							display='flex'
							alignItems='center'
							justifyContent='center'
							cursor='pointer'
							onClick={openCollapse}
						>
							{/* <Image src={forwardArrowIcon} alt='forwardArrow icon' /> */}

							<SVGIcon
								iconName='RightArrowSvg'
								svgProps={{
									width: '17',
									height: '24',
									viewBox: '0 0 17 24',
								}}
								pathProps={{ fill: '#009B76' }}
							/>
						</Box>
					</Flex>
					<Flex
						flexDir='column'
						overflowY='auto'
						sx={{
							'&::-webkit-scrollbar': {
								width: '5px',
								height: '20px',
								backgroundColor: '#F1F3F9',
							},
							'&::-webkit-scrollbar-thumb': {
								backgroundColor: '#009b76',
							},
							'&::-webkit-scrollbar-button': {
								height: '12px',
							},
						}}
					>
						{SidebarOptions.map((menuItem, index) => {
							if (authData) {
								//TODO: fix this with more concrete way
								let export_access = authData.asset_flag_export
								if (export_access === 0) {
								}
								switch (export_access) {
									case 0:
										if (['Export', 'Report'].includes(menuItem.name)) {
											return null
										}
										break
									case 1:
										if (['Report'].includes(menuItem.name)) {
											return null
										}
										break
									case 2:
										if (['Export'].includes(menuItem.name)) {
											return null
										}
										break
								}
								if (
									(export_access === 1 || export_access === 0) &&
									menuItem.name === 'Report'
								) {
									return null
								} else if (
									(export_access === 2 || export_access === 0) &&
									menuItem.name === 'Export'
								) {
									return null
								}
							}

							if (menuItem.isBadge && menuItem.name !== 'Chats') {
								let badgeCount = CheckCount(menuItem.key)
								if (badgeCount === 0) {
									return null
								}
							}

							return loadCollapsedSideBarData(menuItem, index)
						})}
					</Flex>
				</Flex>
			</>
		)
	}

	// TODO: Create hook to load the configuration for the organization.
	return (
		<>
			{sidebarCollapsed?.isCollapsed ||
			localStorage.getItem('isCollapsed') === 'true' ? (
				collapsedSidebar()
			) : (
				<Flex
					maxW='350px'
					minW='350px'
					height='100%'
					flexDir='column'
					pt='15px'
				>
					<Flex
						mb='15px'
						mt='10px'
						justifyContent='flex-start'
						alignItems='center'
					>
						{/* <Image
							src={greneIcon}
							maxW='2.25rem'
							ml={6}
							display='inline-block'
							mb={0}
							mr={1}
						/> */}
						<Box mr='4px' ml={6} display={'inline-block'}>
							<SVGIcon
								iconName='GreenLogoLineSvg'
								svgProps={{
									width: '36',
									height: '10',
									viewBox: '0 0 36 10',
								}}
								// pathProps={{ fill: '#009B76' }}
							/>
						</Box>
						<Flex
							color='#000000'
							fontSize='15px'
							fontWeight={500}
							alignItems='center'
							cursor='pointer'
							onClick={() => {
								// localStorage.setItem("isCollapsed",true)
								sidebarDispatch({ type: sidebarConst.SET_COLLAPSED })
							}}
						>
							&nbsp;{locale['What would you like to work on']}?
							&nbsp;&nbsp;&nbsp;
							{/* <Image
								src={backArrowIcon}
								alt='backArrow icon'
								display='inline-block'
								cursor='pointer'
								onClick={() => {
									// localStorage.setItem("isCollapsed",true)
									sidebarDispatch({ type: sidebarConst.SET_COLLAPSED })
								}}
							/> */}
							<Box
								mr='4px'
								display={'inline-block'}
								cursor='pointer'
								onClick={() => {
									// localStorage.setItem("isCollapsed",true)
									sidebarDispatch({ type: sidebarConst.SET_COLLAPSED })
								}}
							>
								<SVGIcon
									iconName='BackArrowGreenSvg'
									svgProps={{
										width: '12',
										height: '20',
										viewBox: '0 0 12 20',
									}}
									pathProps={{ fill: '#009B76' }}
								/>
							</Box>
						</Flex>
					</Flex>
					<Flex
						flexDir='column'
						alignItems='end'
						marginRight={'10px'}
						overflowY='auto'
						sx={{
							'&::-webkit-scrollbar': {
								width: '3px',
								height: '50px',
								//backgroundColor: `rgb(0,155,118)`,
							},
							'&::-webkit-scrollbar-thumb': {
								backgroundColor: `rgb(0,155,118)`,
							},
							'&::-webkit-scrollbar-button': {
								height: '12px',
							},
						}}
					>
						{SidebarOptions.map((menuItem, index) => {
							if (authData) {
								//TODO: fix this with more concrete way
								let export_access = authData.asset_flag_export
								if (export_access === 0) {
								}
								switch (export_access) {
									case 0:
										if (['Export', 'Report'].includes(menuItem.name)) {
											return null
										}
										break
									case 1:
										if (['Report'].includes(menuItem.name)) {
											return null
										}
										break
									case 2:
										if (['Export'].includes(menuItem.name)) {
											return null
										}
										break
								}
								if (
									(export_access === 1 || export_access === 0) &&
									menuItem.name === 'Report'
								) {
									return null
								} else if (
									(export_access === 2 || export_access === 0) &&
									menuItem.name === 'Export'
								) {
									return null
								}
							}

							if (menuItem.isBadge && menuItem.name !== 'Chats') {
								let badgeCount = CheckCount(menuItem.key)
								if (badgeCount === 0) {
									return null
								}
							}

							return loadSideBar(menuItem, index)
						})}
					</Flex>
				</Flex>
			)}
		</>
	)
}
